import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard-unavailable-message')({
  beforeLoad: () => {
    throw redirect({
      to: '/n/dashboard-unavailable-message',
      replace: true,
    });
  },
});
